const products = [
  { name: "Chiavaye", value: "79" },
  { name: "Chiavaye Personal Moisturizer", value: "92" },
  { name: "Clearcanal", value: "18" },
  { name: "Eustachi", value: "20" },
  { name: "NasaBulb", value: "21" },
  { name: "NasaDock Plus", value: "89" },
  { name: "NasaDrops", value: "22" },
  { name: "NasaFlo Classic Porcelain Neti Pot", value: "77" },
  { name: "NasaFlo NetiPot Clear Plastic", value: "23" },
  { name: "NasaMist All in One Saline Spray", value: "24" },
  { name: "NasaMist Hypertonic Saline Spray", value: "25" },
  { name: "NasaMist Isotonic Saline Spray", value: "26" },
  { name: "NasaMist Isotonic Saline Spray 75ml", value: "84" },
  { name: "NasaMist Saline Spray with Xylitol", value: "27" },
  { name: "NasoGel Drip Free Gel Spray", value: "82" },
  { name: "NasoGel Pediatric", value: "30" },
  { name: "NasoGel Spray", value: "28" },
  { name: "NasoGel Tube", value: "29" },
  { name: "Naspira Battery Operated Aspirator", value: "31" },
  { name: "Naspira Drops", value: "36" },
  { name: "Naspira Filter Replacements", value: "32" },
  { name: "Naspira Nasal-Oral Aspirator", value: "33" },
  { name: "Naspira NeoBulb", value: "34" },
  { name: "Naspira Plus Nasal Oral Aspirator", value: "35" },
  { name: "NeilCleanse Wound Wash 6oz", value: "86" },
  { name: "NeilMed Hydro Pulse Neo", value: "38" },
  { name: "NeilMed Smell Restore", value: "39" },
  { name: "PediaMist Saline Spray", value: "41" },
  { name: "SinuFlo Ready Rinse", value: "42" },
  { name: "SinuFrin", value: "43" },
  { name: "SinuFrin Plus", value: "44" },
  { name: "Sinugator", value: "45" },
  { name: "SinuInhaler Medicated", value: "78" },
  { name: "SinuInhaler Natural Non Medicated", value: "46" },
  { name: "Sinus Rinse Hypertonic Premixed Refill Packets", value: "47" },
  { name: "Sinus Rinse Kit", value: "48" },
  { name: "Sinus Rinse Kit with Xylitol", value: "49" },
  { name: "Sinus Rinse Pediatric Kit", value: "50" },
  { name: "Sinus Rinse Pediatric Packets", value: "87" },
  { name: "Sinus Rinse Pediatric Refill Packets", value: "51" },
  { name: "Sinus Rinse Pediatric Starter Kit", value: "52" },
  { name: "Sinus Rinse Premixed Refill Packets", value: "53" },
  { name: "Sinus Rinse Xylitol Refill Packets 60ct", value: "54" },
  { name: "Sparkling Seawater Saline Spray", value: "40" },
  { name: "SuavEar Ear Wax Removal Aid", value: "55" },
  { name: "Wax Out Ear Cleaners", value: "56" },
];

document.addEventListener("DOMContentLoaded", function () {
  if (typeof storeLocatorPV === "undefined" || !storeLocatorPV) return;

  document.querySelectorAll("a.store-locator").forEach(function (btn) {
    const url = new URL(btn.href);
    url.searchParams.set("pv", storeLocatorPV);
    btn.href = url.href;
  });
});

// Match Buy Locally button width to Add to Cart button
const submitBtn = document.querySelector(".product-form__submit");
const storeLocatorBtn = document.querySelector("a.store-locator");

if (submitBtn && storeLocatorBtn) {
  const submitWidth = submitBtn.offsetWidth;
  storeLocatorBtn.style.width = submitWidth + "px";
}

// Append store logos to logos-container
if (typeof storeLogos !== "undefined" && storeLogos) {
  const observer = new MutationObserver(function (mutations, obs) {
    const logosContainer = document.querySelector(".logos-container");
    if (logosContainer) {
      logosContainer.innerHTML = "";
      storeLogos.split(",").forEach(function (logo) {
        const logoName = logo.trim();
        const logoFile = logoName.replace(/ /g, "_");
        const img = document.createElement("img");
        img.src = `https://www.neilmed.com/store-logos/${logoFile}_logo.jpg`;
        img.alt = logoName + " Logo";
        img.className = logoFile;
        logosContainer.appendChild(img);
      });
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}